import React, { useState } from 'react'
import { otherRepository } from '~/src/repositories'

type TUpladFile = {
  path: string
  filename: string
}
/**
 * useMultipleFileUpload
 * Multiple FileUpload hooks
 * @example
 * ```ts
 *  const {
 *  filesToUpload,
 *  setFilesToUpload,
 *  handleFileChange,
 *  putFileUpload,
 *  handleFileDelete, } = useMultipleFileUpload(initFileData)
 * ```
 * @category ReactHooks
 * @returns
 */
export const useMultipleFileUpload = (initFileData = []) => {
  const [filesToUpload, setFilesToUpload] = useState<File[] | []>(initFileData)

  /**
   * handleFileChange
   * multiple file upload set files
   * @param inputFiles {File[]}
   */
  function handleFileChange(inputFiles: FileList) {
    if (inputFiles.length > 0) {
      const files = Array.from(inputFiles)
      setFilesToUpload([...filesToUpload, ...files])
    }
  }

  /**
   * handleDeleteFile
   * @param selectedFile {File}
   */
  const handleFileDelete = (selectedFile: File) => {
    setFilesToUpload(filesToUpload.filter((item) => item !== selectedFile))
  }

  /**
   * putFileUpload
   * @param filesToUploadData
   */
  const putFileUpload = async (filesToUploadData: File[]): Promise<null | TUpladFile[]> => {
    if (!!filesToUploadData.length) {
      const uploadFileList: TUpladFile[] = []
      for (const file of filesToUpload) {
        // s3のupload先のurlを取得
        const uploadS3BucketPath = await otherRepository.getDownloadFileUrl({
          'Content-Type': file.type,
        })
        // put
        await otherRepository.putFile(file, uploadS3BucketPath.url)
        uploadFileList.push({ filename: file.name, path: uploadS3BucketPath.path })
      }
      return uploadFileList
    }
    return null
  }

  return {
    filesToUpload,
    setFilesToUpload,
    handleFileChange,
    handleFileDelete,
    putFileUpload,
  }
}
